import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const UserProfileService = {
    // getList: async () => {
    //     const response = await apiService.get("/user-profiles");
    //     return response.data;
    // },
    // getbyId: async (id) => {
    //     const response = await apiService.get(`/user-profiles/${id}`);
    //     return response.data;
    // },
    // getBySlug: async (slug) => {
    //     const response = await apiService.get(`/universities/slug`, {
    //         params: { slug }
    //     });
    //     return response.data;
    // }
    applyForPortal: async (payload) => {
        const response = await apiService.post("/portal-access-requests", payload);
        return response.data;
    },
    getApplications: async () => {
        const response = await apiService.get("/portal-access-requests/my");
        return response.data;
    },
    getProfile: async () => {
        const response = await apiService.get("/user-profiles/profile");
        return response.data;
    },
    updateProfile: async (payload) => {
        const response = await apiService.put("/user-profiles/profile", payload);
        return response.data;
    },
}

export default UserProfileService
